import { Link, Stack } from "@mui/material";

export const IconWrapper = ({ icon, href, sx }) => {
  return (
    <Link
      href={href}
      sx={{
        bgcolor: "#FFFFFF",
        borderRadius: "200%",
        boxShadow: "1px 1px 16px rgba(0, 0, 0, 0.1)",
        cursor: "pointer",
      }}
    >
      <Stack
        justifyContent="center"
        alignItems="center"
        width={56}
        height={56}
        sx={{
          color: "primary.main",
          ...sx,
        }}
      >
        {icon}
      </Stack>
    </Link>
  );
};

export const InstagramLogo = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_7758_4571)">
        <path
          d="M12 2.22096C15.2063 2.22096 15.5859 2.23542 16.8469 2.29323C18.0188 2.34622 18.6516 2.54857 19.0734 2.71719C19.6313 2.9388 20.0344 3.20859 20.4516 3.63737C20.8734 4.07096 21.1313 4.48047 21.3469 5.05378C21.5109 5.48737 21.7078 6.14258 21.7594 7.34219C21.8156 8.64297 21.8297 9.0332 21.8297 12.3237C21.8297 15.619 21.8156 16.0092 21.7594 17.3052C21.7078 18.5096 21.5109 19.16 21.3469 19.5936C21.1313 20.1669 20.8687 20.5813 20.4516 21.01C20.0297 21.4436 19.6313 21.7086 19.0734 21.9302C18.6516 22.0988 18.0141 22.3012 16.8469 22.3542C15.5813 22.412 15.2016 22.4264 12 22.4264C8.79375 22.4264 8.41406 22.412 7.15313 22.3542C5.98125 22.3012 5.34844 22.0988 4.92656 21.9302C4.36875 21.7086 3.96563 21.4388 3.54844 21.01C3.12656 20.5764 2.86875 20.1669 2.65313 19.5936C2.48906 19.16 2.29219 18.5048 2.24063 17.3052C2.18438 16.0044 2.17031 15.6142 2.17031 12.3237C2.17031 9.02839 2.18438 8.63815 2.24063 7.34219C2.29219 6.13776 2.48906 5.48737 2.65313 5.05378C2.86875 4.48047 3.13125 4.06615 3.54844 3.63737C3.97031 3.20378 4.36875 2.9388 4.92656 2.71719C5.34844 2.54857 5.98594 2.34622 7.15313 2.29323C8.41406 2.23542 8.79375 2.22096 12 2.22096ZM12 0C8.74219 0 8.33438 0.0144531 7.05469 0.0722656C5.77969 0.130078 4.90313 0.342057 4.14375 0.645573C3.35156 0.963542 2.68125 1.38268 2.01563 2.07161C1.34531 2.75573 0.9375 3.44466 0.628125 4.25404C0.332812 5.03932 0.126563 5.93542 0.0703125 7.24583C0.0140625 8.56589 0 8.98503 0 12.3333C0 15.6816 0.0140625 16.1008 0.0703125 17.416C0.126563 18.7264 0.332812 19.6273 0.628125 20.4078C0.9375 21.222 1.34531 21.9109 2.01563 22.5951C2.68125 23.2792 3.35156 23.7031 4.13906 24.0163C4.90313 24.3198 5.775 24.5318 7.05 24.5896C8.32969 24.6474 8.7375 24.6619 11.9953 24.6619C15.2531 24.6619 15.6609 24.6474 16.9406 24.5896C18.2156 24.5318 19.0922 24.3198 19.8516 24.0163C20.6391 23.7031 21.3094 23.2792 21.975 22.5951C22.6406 21.9109 23.0531 21.222 23.3578 20.4126C23.6531 19.6273 23.8594 18.7313 23.9156 17.4208C23.9719 16.1056 23.9859 15.6865 23.9859 12.3382C23.9859 8.98985 23.9719 8.5707 23.9156 7.25547C23.8594 5.94505 23.6531 5.04414 23.3578 4.26367C23.0625 3.44466 22.6547 2.75573 21.9844 2.07161C21.3188 1.3875 20.6484 0.963542 19.8609 0.650391C19.0969 0.346875 18.225 0.134896 16.95 0.0770833C15.6656 0.0144531 15.2578 0 12 0Z"
          fill="#03559A"
        />
        <path
          d="M12 5.99805C8.59688 5.99805 5.83594 8.83568 5.83594 12.3333C5.83594 15.831 8.59688 18.6686 12 18.6686C15.4031 18.6686 18.1641 15.831 18.1641 12.3333C18.1641 8.83568 15.4031 5.99805 12 5.99805ZM12 16.4428C9.79219 16.4428 8.00156 14.6025 8.00156 12.3333C8.00156 10.0642 9.79219 8.22383 12 8.22383C14.2078 8.22383 15.9984 10.0642 15.9984 12.3333C15.9984 14.6025 14.2078 16.4428 12 16.4428Z"
          fill="#03559A"
        />
        <path
          d="M19.8469 5.74747C19.8469 6.56648 19.2 7.22651 18.4078 7.22651C17.6109 7.22651 16.9688 6.56166 16.9688 5.74747C16.9688 4.92846 17.6156 4.26843 18.4078 4.26843C19.2 4.26843 19.8469 4.93328 19.8469 5.74747Z"
          fill="#03559A"
        />
      </g>
      <defs>
        <clipPath id="clip0_7758_4571">
          <rect width="24" height="24.6667" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const LinkedinLogo = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_7758_4577)">
        <path
          d="M22.2234 0.333374H1.77187C0.792187 0.333374 0 1.10681 0 2.06306V22.599C0 23.5552 0.792187 24.3334 1.77187 24.3334H22.2234C23.2031 24.3334 24 23.5553 24 22.6037V2.06306C24 1.10681 23.2031 0.333374 22.2234 0.333374ZM7.12031 20.7849H3.55781V9.32869H7.12031V20.7849ZM5.33906 7.76775C4.19531 7.76775 3.27188 6.84431 3.27188 5.70525C3.27188 4.56619 4.19531 3.64275 5.33906 3.64275C6.47813 3.64275 7.40156 4.56619 7.40156 5.70525C7.40156 6.83962 6.47813 7.76775 5.33906 7.76775ZM20.4516 20.7849H16.8937V15.2162C16.8937 13.8896 16.8703 12.1787 15.0422 12.1787C13.1906 12.1787 12.9094 13.6271 12.9094 15.1224V20.7849H9.35625V9.32869H12.7687V10.8943H12.8156C13.2891 9.99431 14.4516 9.04275 16.1813 9.04275C19.7859 9.04275 20.4516 11.4146 20.4516 14.499V20.7849Z"
          fill="#03559A"
        />
      </g>
      <defs>
        <clipPath id="clip0_7758_4577">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0 0.333374)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const LinkedinLogoAlt = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.13375 13.9999H1.23125V4.65306H4.13375V13.9999ZM2.68094 3.37806C1.75281 3.37806 1 2.60931 1 1.68118C1 1.23537 1.1771 0.807816 1.49234 0.492579C1.80757 0.177342 2.23513 0.000244141 2.68094 0.000244141C3.12675 0.000244141 3.5543 0.177342 3.86954 0.492579C4.18478 0.807816 4.36188 1.23537 4.36188 1.68118C4.36188 2.60931 3.60875 3.37806 2.68094 3.37806ZM14.9969 13.9999H12.1006V9.44993C12.1006 8.36556 12.0787 6.97493 10.5916 6.97493C9.0825 6.97493 8.85125 8.15306 8.85125 9.37181V13.9999H5.95188V4.65306H8.73562V5.92806H8.77625C9.16375 5.19368 10.1103 4.41868 11.5225 4.41868C14.46 4.41868 15 6.35306 15 8.86556V13.9999H14.9969Z"
        fill="white"
      />
    </svg>
  );
};

export const YoutubeLogo = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.7609 7.53342C23.7609 7.53342 23.5266 5.87874 22.8047 5.15217C21.8906 4.19592 20.8688 4.19124 20.4 4.13499C17.0438 3.89124 12.0047 3.89124 12.0047 3.89124H11.9953C11.9953 3.89124 6.95625 3.89124 3.6 4.13499C3.13125 4.19124 2.10938 4.19592 1.19531 5.15217C0.473438 5.87874 0.24375 7.53342 0.24375 7.53342C0.24375 7.53342 0 9.47874 0 11.4194V13.2381C0 15.1787 0.239062 17.1241 0.239062 17.1241C0.239062 17.1241 0.473437 18.7787 1.19062 19.5053C2.10469 20.4615 3.30469 20.4287 3.83906 20.5319C5.76094 20.7147 12 20.7709 12 20.7709C12 20.7709 17.0438 20.7616 20.4 20.5225C20.8688 20.4662 21.8906 20.4615 22.8047 19.5053C23.5266 18.7787 23.7609 17.1241 23.7609 17.1241C23.7609 17.1241 24 15.1834 24 13.2381V11.4194C24 9.47874 23.7609 7.53342 23.7609 7.53342ZM9.52031 15.4459V8.70061L16.0031 12.085L9.52031 15.4459Z"
        fill="#03559A"
      />
    </svg>
  );
};

export const TwitterLogo = () => {
  return (
    <svg
      width="16"
      height="14"
      viewBox="0 0 16 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.3553 3.741C14.3655 3.88313 14.3655 4.02528 14.3655 4.16741C14.3655 8.50241 11.066 13.4973 5.03553 13.4973C3.17766 13.4973 1.45178 12.9593 0 12.0253C0.263969 12.0557 0.51775 12.0659 0.791875 12.0659C2.32484 12.0659 3.73603 11.5481 4.86294 10.6649C3.42131 10.6344 2.21319 9.69025 1.79694 8.39075C2 8.42119 2.20303 8.4415 2.41625 8.4415C2.71066 8.4415 3.00509 8.40088 3.27919 8.32985C1.77666 8.02525 0.649719 6.70547 0.649719 5.11157V5.07097C1.08625 5.31463 1.59391 5.46691 2.13194 5.48719C1.24869 4.89835 0.670031 3.89329 0.670031 2.75622C0.670031 2.1471 0.832437 1.58872 1.11672 1.10141C2.73094 3.09125 5.15734 4.39072 7.87812 4.53288C7.82737 4.28922 7.79691 4.03544 7.79691 3.78163C7.79691 1.9745 9.25884 0.502441 11.0761 0.502441C12.0202 0.502441 12.873 0.898379 13.472 1.53797C14.2131 1.39585 14.9238 1.12172 15.5532 0.746098C15.3096 1.50754 14.7918 2.14713 14.1116 2.55319C14.7715 2.48216 15.4111 2.29938 15.9999 2.0456C15.5533 2.69532 14.9949 3.27397 14.3553 3.741V3.741Z"
        fill="white"
      />
    </svg>
  );
};

export const FacebookLogo = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.7231 9L12.1675 6.10437H9.38908V4.22531C9.38908 3.43313 9.77721 2.66094 11.0216 2.66094H12.2847V0.195625C12.2847 0.195625 11.1385 0 10.0425 0C7.75439 0 6.25877 1.38688 6.25877 3.8975V6.10437H3.71533V9H6.25877V16H9.38908V9H11.7231Z"
        fill="white"
      />
    </svg>
  );
};

export const WhatsappLogo = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.9031 3.03437C11.5937 1.72187 9.85 1 7.99687 1C4.17187 1 1.05937 4.1125 1.05937 7.9375C1.05937 9.15937 1.37813 10.3531 1.98438 11.4062L1 15L4.67812 14.0344C5.69062 14.5875 6.83125 14.8781 7.99375 14.8781H7.99687C11.8187 14.8781 15 11.7656 15 7.94063C15 6.0875 14.2125 4.34687 12.9031 3.03437V3.03437ZM7.99687 13.7094C6.95937 13.7094 5.94375 13.4312 5.05937 12.9062L4.85 12.7812L2.66875 13.3531L3.25 11.225L3.1125 11.0063C2.53437 10.0875 2.23125 9.02813 2.23125 7.9375C2.23125 4.75938 4.81875 2.17188 8 2.17188C9.54062 2.17188 10.9875 2.77187 12.075 3.8625C13.1625 4.95312 13.8313 6.4 13.8281 7.94063C13.8281 11.1219 11.175 13.7094 7.99687 13.7094V13.7094ZM11.1594 9.39062C10.9875 9.30313 10.1344 8.88437 9.975 8.82812C9.81563 8.76875 9.7 8.74062 9.58438 8.91562C9.46875 9.09062 9.1375 9.47813 9.03438 9.59688C8.93438 9.7125 8.83125 9.72812 8.65938 9.64062C7.64063 9.13125 6.97188 8.73125 6.3 7.57812C6.12188 7.27187 6.47812 7.29375 6.80937 6.63125C6.86562 6.51562 6.8375 6.41562 6.79375 6.32812C6.75 6.24063 6.40313 5.3875 6.25938 5.04063C6.11875 4.70313 5.975 4.75 5.86875 4.74375C5.76875 4.7375 5.65312 4.7375 5.5375 4.7375C5.42187 4.7375 5.23437 4.78125 5.075 4.95312C4.91562 5.12812 4.46875 5.54688 4.46875 6.4C4.46875 7.25313 5.09063 8.07813 5.175 8.19375C5.2625 8.30938 6.39687 10.0594 8.1375 10.8125C9.2375 11.2875 9.66875 11.3281 10.2188 11.2469C10.5531 11.1969 11.2437 10.8281 11.3875 10.4219C11.5312 10.0156 11.5313 9.66875 11.4875 9.59688C11.4469 9.51875 11.3313 9.475 11.1594 9.39062Z"
        fill="white"
      />
    </svg>
  );
};

export const TiktokLogo = () => {
  return (
    <svg fill="#03559A" width="24px" height="24px" viewBox="0 0 512 512" id="icons" xmlns="http://www.w3.org/2000/svg" stroke="#03559A"><g id="SVGRepo_bgCarrier"></g><g id="SVGRepo_tracerCarrier"></g><g id="SVGRepo_iconCarrier"><path d="M412.19,118.66a109.27,109.27,0,0,1-9.45-5.5,132.87,132.87,0,0,1-24.27-20.62c-18.1-20.71-24.86-41.72-27.35-56.43h.1C349.14,23.9,350,16,350.13,16H267.69V334.78c0,4.28,0,8.51-.18,12.69,0,.52-.05,1-.08,1.56,0,.23,0,.47-.05.71,0,.06,0,.12,0,.18a70,70,0,0,1-35.22,55.56,68.8,68.8,0,0,1-34.11,9c-38.41,0-69.54-31.32-69.54-70s31.13-70,69.54-70a68.9,68.9,0,0,1,21.41,3.39l.1-83.94a153.14,153.14,0,0,0-118,34.52,161.79,161.79,0,0,0-35.3,43.53c-3.48,6-16.61,30.11-18.2,69.24-1,22.21,5.67,45.22,8.85,54.73v.2c2,5.6,9.75,24.71,22.38,40.82A167.53,167.53,0,0,0,115,470.66v-.2l.2.2C155.11,497.78,199.36,496,199.36,496c7.66-.31,33.32,0,62.46-13.81,32.32-15.31,50.72-38.12,50.72-38.12a158.46,158.46,0,0,0,27.64-45.93c7.46-19.61,9.95-43.13,9.95-52.53V176.49c1,.6,14.32,9.41,14.32,9.41s19.19,12.3,49.13,20.31c21.48,5.7,50.42,6.9,50.42,6.9V131.27C453.86,132.37,433.27,129.17,412.19,118.66Z"></path></g></svg>
    )
}


